
// Pure filename helpers for the Tværprofiler PDF export (task section 1) -
// no DOM/THREE dependency, so this is Level 1 (Vitest) tested directly,
// unlike the rest of the crosssection/ folder.

import {t} from "../i18n/index.js";

const UNSAFE_FILENAME_CHARS = /[<>:"/\\|?*\x00-\x1F]/g;

// Strips a trailing file extension (".laz", ".las", ...) - a leading dot
// (dotfile-style name with no real extension) is left alone, since
// `lastIndexOf(".") === 0` is deliberately excluded by the `> 0` check.
export function stripFileExtension(name){
	const idx = name.lastIndexOf(".");
	return idx > 0 ? name.slice(0, idx) : name;
}

// Replaces characters that are unsafe/reserved in Windows and POSIX
// filenames, collapses whitespace and repeated underscores, and trims any
// leading/trailing underscore or dot left behind by that collapsing.
export function sanitizeFilenameSegment(text){
	return text
		.replace(UNSAFE_FILENAME_CHARS, "_")
		.replace(/\s+/g, "_")
		.replace(/_+/g, "_")
		.replace(/^[_.]+|[_.]+$/g, "");
}

// "Profilrapport_(punktskynavn).pdf" (task section 1), e.g.
// "fjernvarme_stor.laz" -> "Profilrapport_fjernvarme_stor.pdf". Falls back
// to a plain "Profilrapport.pdf" when the data source is unknown, or when
// sanitizing happens to strip it down to nothing (e.g. a name that was
// entirely unsafe characters).
export function buildCrossSectionReportFilename(dataSource){
	if(!dataSource) return t("Profilrapport.pdf");
	const base = sanitizeFilenameSegment(stripFileExtension(dataSource));
	return base ? t("Profilrapport_{0}.pdf", base) : t("Profilrapport.pdf");
}
